import request from '@/utils/request'

let PromotionApi = {
    getPromotionDetail(data){
         return request._post('/shop/plus.agent.Team/getPromotionDetail', data);
    },
    getPromotionStats(data){
        return request._post('/shop/plus.agent.Team/getPromotionStats', data);
    },
    getTeamInfo(data){
         return request._post('/shop/plus.agent.Team/getTeamInfo', data);
    },
    getPromotionList(data){
         return request._post('/shop/plus.agent.Team/getPromotionList', data);
    },
    getPromotionAnalysis(data){
         return request._post('/shop/plus.agent.Team/getPromotionAnalysis', data);
    },
      searchUser(data) {
        return request._post('/shop/plus.agent.Team/searchUser', data);
      }
}
export default PromotionApi;



// WEBPACK FOOTER //
// ./src/api/promotion.js